<ion-header mode="ios">
    <ion-toolbar color="primary">
        <ion-buttons class="ion-padding" slot="end">
            <ion-button fill="clear"
                        (click)="dismiss()"
                        shape="round">
                <ion-icon name="close-outline" slot="icon-only"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding">
    <div class="login-modal__content">
<!--        <ion-img-->
<!--            class="header__logo"-->
<!--            src="{{ appConfig.server.logoPath }}"-->
<!--            alt="Organization Logo"></ion-img>-->

<!--        <ion-item-divider class="login-modal__divider ion-margin-bottom" color="medium">-->
<!--            <ion-label class="section__subtitle">Log In</ion-label>-->
<!--        </ion-item-divider>-->
        <div class="login-modal__label ion-margin ion-padding">
            <ion-text color="primary">Log In</ion-text>
        </div>

        <ion-grid class="ion-no-padding ion-margin-bottom" *ngIf="errorMessage">
            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <div class="vesta-input-block__error-message--custom vesta-input-block__error-message--login">
                        {{ errorMessage }}
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>

        <form class="login-modal__form"
              novalidate
              #loginForm="ngForm"
              (ngSubmit)="login(loginForm)"
              (keyup.enter)="login(loginForm)">
            <ion-item class="ion-no-padding"
                      [ngClass]="{ 'vesta-input-block__item--has-error': email.touched && email.errors }">
                <ion-icon [ngClass]="{ 'vesta-input-block__icon--has-error': email.touched && email.errors }"
                          name="mail-outline"
                          slot="start"></ion-icon>
                <ion-input [ngClass]="{ 'vesta-input-block__input--has-error': email.touched && email.errors }"
                           id="email"
                           type="email"
                           name="email"
                           placeholder="Email"
                           aria-label="Email"
                           mode="ios"
                           inputmode="email"
                           debounce="1000"
                           (ionInput)="handleEmailInput($event)"
                           clear-input="true"
                           required="true"
                           autofocus="true"
                           [disabled]="loading"
                           ngModel
                           #email="ngModel"></ion-input>
                <ion-spinner name="bubbles" slot="end" *ngIf="checkingEmail"></ion-spinner>
            </ion-item>
            <div class="vesta-input-block__error-message" *ngIf="email.touched && email.errors">
                <ion-note color="danger">Email is required</ion-note>
            </div>

            <ion-item class="ion-no-padding ion-margin-top"
                      [ngClass]="{ 'vesta-input-block__item--has-error': password.touched && password.errors,
                                   'ion-hide': !showPasswordField
                                 }">
                <ion-icon [ngClass]="{ 'vesta-input-block__icon--has-error': password.touched && password.errors }"
                          slot="start"
                          name="lock-closed-outline"></ion-icon>
                <ion-input [ngClass]="{ 'vesta-input-block__input--has-error': password.touched && password.errors }"
                           id="password"
                           type="password"
                           name="password"
                           placeholder="Password"
                           aria-label="Password"
                           mode="ios"
                           inputmode="password"
                           clear-input="true"
                           [required]="showPasswordField"
                           [disabled]="loading"
                           ngModel
                           #password="ngModel"></ion-input>
            </ion-item>
            <div class="vesta-input-block__error-message" *ngIf="password.touched && password.errors">
                <ion-note color="danger">Password is required</ion-note>
            </div>

            <div class="login-modal__forgot-password-container"
                 [ngClass]="{ 'ion-hide': !showPasswordField }">
                <span class="login-modal__forgot-password-link" (click)="navigateToForgotPasswordPage()">Forgot Password?</span>
            </div>

            <ion-button type="submit"
                        [disabled]="loading || loginForm.invalid"
                        shape="round"
                        strong="true"
                        expand="block">
                <ion-spinner name="bubbles" *ngIf="loading"></ion-spinner>
                {{ loading ? '' : 'Log In' }}
            </ion-button>

<!--            <ion-item-divider></ion-item-divider>-->
        </form>

        <div class="login-modal__new-customer" *ngIf="!isLandingPage">
<!--            <ion-item-divider class="login-modal__divider ion-margin-bottom" color="success">-->
<!--                <ion-label class="section__subtitle">New Customer?</ion-label>-->
<!--            </ion-item-divider>-->

            <div class="login-modal__label">
                <ion-text color="primary">New Customer?</ion-text>
            </div>

            <ion-button shape="round"
                        [disabled]="loading"
                        (click)="signup()"
                        strong="true"
                        color="light"
                        expand="block">Sign Up</ion-button>
        </div>
    </div>
</ion-content>
